import ApiService from './apiService';

class BrokerSyncService extends ApiService {
  private static instance?: BrokerSyncService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!BrokerSyncService.instance) {
      BrokerSyncService.instance = new BrokerSyncService();
    }
    return BrokerSyncService.instance;
  }

  syncWithLos(syncType: 'PushToLOS' | 'PullFromLOS'): Promise<{ createdCount: number }> {
    return this.client.post(`/configuration/external-brokers/sync/${syncType}`).then((response) => response.data);
  }
}

export default BrokerSyncService;
